import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";
import * as moment from "moment";

export function getEvents(start?: moment.Moment, end?: moment.Moment, includeTime: boolean = false): JQueryPromise<modelsGet.IEvent[]>
{
    var endpoint = new URI("api/events");
    endpoint.addQuery({
        start: ((start != null) ? start.toISOString() : undefined),
        end: ((end != null) ? end.toISOString() : undefined),
        includeTime: includeTime
    });

    return api.get<modelsGet.IEvent[]>({
        endpoint: endpoint.href()
    });
}

export function getEvent(id: number): JQueryPromise<modelsGet.IEvent>
{
    var endpoint = new URI("api/events");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IEvent>({
        endpoint: endpoint.href()
    });
}

export function getEventLinks(eventId: number, parentId: number): JQueryPromise<modelsGet.ILink[]>
{
    var endpoint = new URI("api/events/links");
    endpoint.addQuery({
        eventId: eventId,
        parentId: parentId
    });

    return api.get<modelsGet.ILink[]>({
        endpoint: endpoint.href()
    });
}

export function getComments(eventId: number): JQueryPromise<modelsGet.IComment[]>
{
    var endpoint = new URI("api/events/comments");
    endpoint.segment(eventId.toString());

    return api.get<modelsGet.IComment[]>({
        endpoint: endpoint.href()
    });
}

export function postSearch(model: modelsPost.ISearch): JQueryPromise<modelsGet.IEvent[]>
{
    return <any>api.post({
        contentType: "application/json",
        endpoint: "api/events/search",
        data: JSON.stringify(model)
    });
}

export function postSearchPaging(model: modelsPost.ISearch, pageNo?: number, pageSize?: number): JQueryPromise<modelsGet.IPagedResult<modelsGet.IEvent>>
{
    var endpoint = new URI("api/events/search");

    if (pageNo != null)
        endpoint.setQuery("pageNo", pageNo.toString());

    if (pageSize != null)
        endpoint.setQuery("pageSize", pageSize.toString());

    return <any>api.post({
        contentType: "application/json",
        endpoint: endpoint.href(),
        data: JSON.stringify(model)
    });
}

export function postComment(model: modelsPost.IComment): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/events/comment",
        data: JSON.stringify(model)
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(event: modelsPost.IEvent): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/events",
        data: JSON.stringify(event)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, event: modelsPost.IEvent): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/events/${id}`,
        data: JSON.stringify(event)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/events/delete/${id}`
    });
}

export function archive(id: number, reason: modelsPost.IEventArchive): JQueryPromise<any>
{
    return api.remove({
        contentType: "application/json",
        endpoint: `api/events/archive/${id}`,
        data: JSON.stringify(reason)
    });
}